import { render } from "./TeamingSegmentedButton.vue?vue&type=template&id=6cccdfc9&scoped=true"
import script from "./TeamingSegmentedButton.vue?vue&type=script&lang=js"
export * from "./TeamingSegmentedButton.vue?vue&type=script&lang=js"

import "./TeamingSegmentedButton.vue?vue&type=style&index=0&id=6cccdfc9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cccdfc9"

export default script